/*
view_paymentmessage
*/

import notifications from '../../commonview/lib/view-binaryquestion.js';
import constants from '../../common/lib/utils/constants.js';
import core from '../../common/lib/core.js';

const create = core.create; // creates basic elements not inserted into the dom
const notvalidClass = 'payment__message-not-valid';

const elements = {
	wrap: null,
	subwrap: null,
	message: null,
	title: null
};

function createSubwrap() {
	return create({
		type: 'div',
		class: 'payment__div-wrap-message'
	});
}

function createMessage() {
	return create({
		type: 'p',
		class: 'payment__p-message'
	});
}

function createTitle() {
	return create({
		type: 'p',
		class: 'payment__p-message-title'
	});
}

function assembleElements() {
	/*
	<div>
		<p>
		<p>
	</div>
	*/
	elements.subwrap = (elements.subwrap || createSubwrap());
	elements.message = (elements.message || createMessage());
	elements.title = (elements.title || createTitle());
	elements.subwrap.appendChild(elements.title);
	elements.subwrap.appendChild(elements.message);
	elements.wrap.appendChild(elements.subwrap);
	elements.assembled = true;
}

function updateContent(p) {
	if (p.title) {
		elements.title.innerHTML = p.title;
	} else {
		console.warn('view_paymentmessage:72:updateContent: can not update title:', p);
	}
	if (p.message) {
		elements.message.innerHTML = p.message;
	} else {
		console.warn('view_paymentmessage:78:updateContent: can not update message:', p);
	}
}

function updateStyle(success) {
	if (!success) {
		core.addClass(elements.subwrap, notvalidClass);
	} else {
		core.removeClass(elements.subwrap, notvalidClass);
	}
}

function deleteAllElements() {
	/* The object-property must either contain an element or an array with elements*/
	/* The wrapper is not deleted.*/
	if (elements && elements.assembled) {
		core.deleteElementsInObjectExcept(elements, ['wrap', 'before', 'textkeys'], 'view_paymentmessage:81');
		elements.assembled = false;
	}
}

export default {
	init(p) {
		/* Validate input, store reference to wrapper */
		elements.wrap = core.getElementIfValid(p, 'wrap', 'view_pending_withdrawals:267');
		if (!elements.assembled) {
			assembleElements();
		}
	},
	update(state) {
		let paymentResultData = null;
		let paymentState = null;
		let providerResultText = null;
		let submitPaymentData = null;

		function emptyFkn() {
		}

		function doNothing() {}

		if (state.get_payment_result) {
			paymentResultData = state.get_payment_result.paymentResultData;
			paymentState = paymentResultData.state;
			providerResultText = paymentResultData.providerResultText;
			if (paymentState === constants.SUCCESS) {
				/* successfulmode is one of:
				* deposit-with-bonus (both money and bonus, not cc)
				* deposit (just money, not cc)
				* no-deposit (just free round bonus, no money, not cc)
				* provider-result (credit card deposit of some kind), and then having providerResultText
				* paymentState may also have the values:
				* constants.CANCELLED
				* constants.PENDING
				*/
				notifications.showConfirmationMessage('default-success', 'Title', providerResultText, 'OK', emptyFkn);
			}
			updateStyle(paymentState);
			updateContent({
				title: paymentResultData.errorMessage.title,
				message: paymentResultData.errorMessage.message
			});
		}

		if (state.submit_payment) {
			submitPaymentData = state.submit_payment;
			if (!submitPaymentData.success) {
				notifications.showConfirmationMessage('default-success', submitPaymentData.title, submitPaymentData.message, 'OK', doNothing);
			}
		}
	},
	close() {
		deleteAllElements();
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/payment/lib/view-paymentmessage.js